import { ref } from '@vue/composition-api'
import { fetchNext7DaysMatches } from '@ms/api/match'
import useCreateMatches from '@ms/components/match/useCreateMatches.js'

export default function useNext7Days() {
  const { matches: next7DaysMatches, resetMatches, setMatches } = useCreateMatches()

  const next7DaysMatchesCount = ref(0)

  const resetNext7DaysCount = () => {
    next7DaysMatchesCount.value = 0
  }

  const resetNext7DaysMatches = () => {
    resetNext7DaysCount()
    resetMatches()
  }

  const setNext7DaysMatches = ({ events = [], matchesCount = 0 }) => {
    setMatches(events)
    next7DaysMatchesCount.value = matchesCount
  }

  // 获取七日比赛
  async function getNext7DaysMatches(sportId = '') {
    const { error, data } = await fetchNext7DaysMatches(sportId)
    if (error) {
      return Promise.reject(error)
    } else {
      setNext7DaysMatches(data)
    }
  }

  return {
    next7DaysMatches,
    next7DaysMatchesCount,
    resetNext7DaysCount,
    resetNext7DaysMatches,
    getNext7DaysMatches
  }
}
